import {z} from '@hono/zod-openapi';

export const mobileDeRefdataRequestSchema = z
  .object({
    tenantId: z.string().uuid(),
    vehicle: z.object({
      type: z.string().min(1).openapi({example: 'VEHICLETYPE_PASSENGER_CAR'}),
      make: z.string().min(1).openapi({example: 'MAKE_VOLKSWAGEN'}),
      modelFamily: z.string().min(1).openapi({example: 'MAKE_VOLKSWAGEN-MODELFAMILY_PASSAT'}),
      fuelType: z.string().nullable().openapi({example: 'FUELTYPE_DIESEL'}),
      hybridType: z.string().nullable(),
      bodyStyle: z.string().nullable().openapi({example: 'CARSTYLE_ESTATE_CAR'}),
      transmission: z.string().nullable().openapi({example: 'TRANSMISSION_AUTOMATIC'}),
    }),
    firstRegistrationOn: z.string().date().openapi({example: '2020-01-15'}),
  })
  .openapi('MobileDeRefdataRequest');

export type MobileDeRefdataRequest = z.infer<typeof mobileDeRefdataRequestSchema>;
